/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbol, DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {TorpedoPart} from "../../view/parts/TorpedoPart";

export function isTorpedoSymbol(value:any):value is TorpedoSymbol {
    return value.symbolName === "T";
}


export class TorpedoSymbol extends DasUBootSymbol {
    private torpedoPart:TorpedoPart;

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName);
        //this.addTorpedoPart(reel.reelId, 0);
    }


    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();

        switch (state) {

            case DasUBootSymbolStates.LANDING:
                tl = super.getStateAnimation(state);
                if (this.isVisibleInReel()) {
                    tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.TORPEDO_LANDING));
                    tl.add(() => {DasUBoot.reelView.getLandingShake(false).play(0)});
                }
                break;
            default:
                tl = super.getStateAnimation(state);

        }

        this._stateAnimation = tl;
        return tl;
    }


    public addTorpedoPart(value:number = 1) {
        let isWild = false;
        if ((this.reel.reelId == 2 || this.reel.reelId == 3)) {
            isWild = true;
        }

        if (this.torpedoPart != undefined) {
            this.torpedoPart.setValue(value);
        } else {
            this.torpedoPart = new TorpedoPart(value, isWild);
            this.maskedView.addChild(this.torpedoPart);
        }
    }

    public removeTorpedoPart() {
        if (this.torpedoPart) {
            this.maskedView.removeChild(this.torpedoPart);
        }
    }


    public upgradePart(value:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        if (this.torpedoPart) {
            tl.add(()=>this.torpedoPart.setValue(value));
            tl.add(this.torpedoPart.getFlash())
        }
        return tl;
    }
}